import jQuery from 'jquery';

export default function(){
    jQuery('.fundings-accordion-wrapper').each(function(){
        let $wrapper    = jQuery(this);
        let $accordions = $wrapper.find('.fundings-accordion');

        $accordions.on('click', function(){
            $accordions.removeClass('active');
            jQuery(this).addClass('active');

            let $a = jQuery(this);

            setTimeout(function(){
                jQuery('html, body').animate({
                    scrollTop: $a.offset().top
                }, 600);
            }, 800);
        });

        if( $accordions.length > 0 && $wrapper.hasClass('fundings-accordion-autoopen') ){
            $accordions.first().addClass('active');
        }
    });
}